/**
 * Kolumner som göms per kommun. Nyckeln är kommunnamnet, inte tenant-id.
 *
 * `Antal flaggor` (#6) syns som förval i alla kommuner. Ska den stängas av någonstans
 * räcker det att lägga till den i listan för den kommunen:
 *
 *   Jönköping: ['Öppen process', 'Antal flaggor'],
 *
 * Användaren kan dessutom välja bort den själv via "Rensa bortvalda kolumner".
 */
export const HIDDEN_COLUMNS: Record<string, string[] | undefined> = {
  Jönköping: ['Öppen process'],
}
